import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9cxxv7b6ep: FaireBrandEntity = {
  token: "b_9cxxv7b6ep",
  type: "brand",
  name: "plant alchemy remedies",
  avatarUrl:
    "https://cdn.faire.com/fastly/9a5a524d9f026787ac87336e7ef9dd8c5dfa7b8b86d3e6da9001568c27e76d69.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/9280ab08d4283eea38e6d43838e6734f76de4a586e03d5fe8c4002fe2a1081a7.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9a5a524d9f026787ac87336e7ef9dd8c5dfa7b8b86d3e6da9001568c27e76d69.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9280ab08d4283eea38e6d43838e6734f76de4a586e03d5fe8c4002fe2a1081a7.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 0,
  rating: 4.7,
  reviewCount: 19,
  isInsider: true,
  description:
    "The Alchemist's Kitchen and Plant Alchemy offers a range of premium botanical products that combine the wisdom of ancient cultures with modern science for a holistic approach to health and wellness.\n\nWe believe that the power of plants and medicinal mushrooms should be accessible to all who are seeking an optimal mind, body, and spirit connection.\n\nBy collaborating with farmers, botanists, and experts who share our ethos and mission, integrity is ensured from cultivation to distribution.\n\nOur range of products begins with the cultivation and extraction of the finest CBD formulations intended for the relief of stress, and muscular discomfort. \n\nOur State-Changing Plant-based Elixirs offer you the opportunity to enjoy a socially relaxing experience as an option to alcoholic beverages. \n\nOur herbal remedies, detox cleanses, and medicinal mushroom tinctures are of the finest quality, intended for cognitive health, longevity, vitality, and the relaxation of the nervous system.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:26.791Z",
    importedBy: "entity-db-cli",
  },
};
